export default {
  GET_BOOK_MARKS(state, payload) {
    state.getbookMarks = payload;
  },
  SELECTED_BOOK_MARKS(state, payload) {
    state.selectedbookMarks = payload;
  },
};
